import { openSubOrderModal } from '../../../State/subOrderModal'

export default () => (dispatch, getState) => {

  const { subOrder } = getState().screens.SubOrder
  
  // Use the subOrder's own total
  const orderTotal = subOrder ? subOrder.total : null
  
  dispatch(openSubOrderModal({
    orderTotal,
  }))

}
